import { FaUserPlus, FaSearch, FaTags, FaShoppingBag } from "react-icons/fa";
import { Section, SectionTitle, SectionSubtitle, StepsGrid, StepCard, StepIconWrapper, StepNumber } from "./style";

const steps = [
	{
		icon: FaUserPlus,
		title: "Crie sua conta",
		description: "Cadastre-se gratuitamente em poucos segundos e comece a aproveitar.",
	},
	{
		icon: FaSearch,
		title: "Encontre lojas",
		description: "Explore as melhores lojas e restaurantes da sua região.",
	},
	{
		icon: FaTags,
		title: "Ganhe descontos",
		description: "Aproveite cupons exclusivos e programas de fidelidade.",
	},
	{
		icon: FaShoppingBag,
		title: "Faça seu pedido",
		description: "Compre online com os melhores preços e receba em casa.",
	},
];

export function HowItWorks() {
	return (
		<Section>
			<div className="container">
				<div className="text-center">
					<SectionTitle>Como funciona?</SectionTitle>
					<SectionSubtitle>
						É simples e rápido. Siga os passos abaixo e comece a economizar agora mesmo.
					</SectionSubtitle>
				</div>
				<StepsGrid>
					{steps.map((step, index) => {
						const Icon = step.icon;
						return (
							<StepCard key={step.title}>
								<StepIconWrapper>
									<Icon size={28} />
									<StepNumber>{index + 1}</StepNumber>
								</StepIconWrapper>
								<h3>{step.title}</h3>
								<p>{step.description}</p>
							</StepCard>
						);
					})}
				</StepsGrid>
			</div>
		</Section>
	);
}
